var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.detailsRows),function(row,idx){return _c('review-row',{key:("/review-row-" + idx),attrs:{"title":row.title,"subtitle":row.subtitle,"hide-bottom-border":idx === _vm.detailsRows.length - 1}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }